import React, { Component,PropTypes } from 'react';
import render from "react-dom";
import { Link,hashHistory } from "react-router";
import {ellaUrl} from '../../../path.config'
import Tip from 'COMPONENT/tip'
import FormInput from 'COMPONENT/form/formInput'
import {getUserId,resultTip,errorShow,language,errToSuc} from "UTIL/common"
import ellaService from 'SERVICES/purifier/ella/ellaService'
export default class RoleAdd extends Component {
	constructor(props) {
		super(props);
		this.btnSubmit = this.btnSubmit.bind(this);
		this.state = {
			nodeVos:[],
			url:ellaUrl
		};
	}
	
	btnSubmit(event){
        event.preventDefault();
        errToSuc();
		var name = $.trim($("#name").val());
		var remark = $.trim($("#remark").val());

		var arr = {
			name:name,
			remark:remark,
		};
		var data =JSON.stringify(arr);
        var ids = ['name'];
        for(let i in ids){
            if(arr[ids[i]]==''){
                errorShow(ids[i]);
            }
        }
        if($("[name='error']").length == 0) {
            ellaService.userTypeDoAddOrUpdate({data}).then(body => {
                resultTip(body, '/ella/user/usertype/userTypeIndex')
            })
        }
	}
	render() {
		return (
			<div >
				<section className="content-header " >
			        <h1> {language()['userType']} <small>{language()['userTypeAdd']}</small> </h1>
			    </section>
			    <section className="content" >
		        <div className="box box-primary color-palette-box">
		            <div className="box-header with-border">
		               	<i className="fa fa-plus-circle"></i>
		                <h3 className="box-title">{language()['userTypeAdd']}</h3>
		            </div>
		            <div className="box-body">
		                <Tip ids=""/>
		             	<form className="form-horizontal">
							<FormInput name="userTypeName" id="name"/>
			             	<div className="row form-group">
			             		<label  className="multi-label control-label col-xs-2">{language()['remark']}</label>
					            <div className="col-xs-3">
						            <textarea className="form-control" id="remark" ></textarea>
						        </div>
			             	</div>
			             	<div className="row form-group">
			             		<div className="col-xs-2"></div>
						        <div className="col-xs-1 text-center">
						            <a className="btn btn-success" onClick={this.btnSubmit}>{language()['submit']}</a>
						        </div>
					            <div className="col-xs-1 text-center">
					                <Link  to = "/ella/user/usertype/userTypeIndex" className="btn btn-default btn-md">
										{language()['return']}
		                    		</Link>
					            </div>
					        </div> 
		             	</form>
		        	</div>
				</div>
				</section>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./modules/ella/user/userType/userTypeAdd.js